
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Declare gtag as a global function
declare global {
  interface Window {
    gtag: (
      command: 'config' | 'event' | 'js' | 'set', 
      targetId: string, 
      config?: Record<string, any>
    ) => void;
    dataLayer: any[];
  }
}

export const useAnalytics = () => {
  const location = useLocation();
  
  // Track page views
  useEffect(() => {
    if (typeof window.gtag !== 'undefined') {
      // Track page view for both GA4 and Google Tags
      window.gtag('config', 'G-PT5R0TCKPE', {
        page_path: location.pathname + location.search
      });
      
      window.gtag('config', 'GT-PZ6CB6M', {
        page_path: location.pathname + location.search
      });
    }
  }, [location]);
  
  // Function to track custom events
  const trackEvent = (
    action: string, 
    category: string, 
    label: string, 
    value?: number
  ) => {
    if (typeof window.gtag !== 'undefined') {
      // Send event to both GA4 and Google Tags
      window.gtag('event', action, {
        event_category: category,
        event_label: label,
        value: value
      });
    }
  };
  
  return { trackEvent };
};
